import clsx from 'clsx';

export const InfoCard = ({
  text,
  title,
  startScore,
  endScore,
}: {
  text: string;
  title: string;
  startScore?: number;
  endScore?: number;
}) => {
  return (
    <div className="rounded-lg bg-card px-4 py-3">
      <div className="mb-3 flex items-center justify-between">
        <div className="text-sm text-additional">{title}</div>
        {(!!startScore || !!endScore) && (
          <div className="flex items-center gap-3">
            {Boolean(startScore) && (
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-error text-xs font-bold">
                {startScore}
              </div>
            )}
            {Boolean(endScore) && startScore !== endScore && (
              <img
                src="/icons/back_arrow.svg"
                alt="arr"
                className="h-6 w-6 rotate-180"
              />
            )}
            {Boolean(endScore) && endScore !== startScore && (
              <div
                className={clsx(
                  'flex h-6 w-6 items-center justify-center rounded-full bg-success text-xs font-bold',
                  startScore! < endScore! && 'bg-error'
                )}
              >
                {endScore}
              </div>
            )}
          </div>
        )}
      </div>
      <div>{text}</div>
    </div>
  );
};
